import { Component, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ReportsService } from "@modules/report/services/report-service/report.service";
import { Observable, share } from "rxjs";
import { Report } from "../../models/report.interface";

@Component({
  selector: "icr-report-nav",
  templateUrl: "./report-nav.component.html",
  styleUrls: ["report-nav.component.scss"],
  standalone: false,
})
export class ReportNavComponent {
  ngOnInit() {
    this.getActiveHeader();
  }

  @Input() data: Report[] = [];
  claimNumberString: string;
  activeHeader: string;

  activeFragment$: Observable<string | null> = this.route.fragment.pipe(
    share()
  );

  constructor(
    private reportsService: ReportsService,
    public route: ActivatedRoute
  ) {
    this.claimNumberString = this.route.snapshot.params.claimNumber;
    this.activeHeader = "fnolSummary";
  }

  getActiveHeader(): void {
    this.reportsService.getActiveHeader$().subscribe((activeHeaderData) => {
      this.activeHeader = activeHeaderData;
    });
  }

  public scrollTo(ele: string): void {
    const element: Element | null = document.querySelector(`#${ele}`);
    if (element) element.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
